import { Complaint } from '../Complaint'
import { formSchema } from './schema'
import { medicalIdTheft } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class MedicalIdentityTheftComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'medical_identity_theft'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.medicalidtheft.confirmation
  }
}

export default withRecaptcha(
  withBackButtonProtection(
    withDocTitle(MedicalIdentityTheftComplaint, medicalIdTheft)
  )
)
